import useOptimizelyExperimentVariation from '@/optimizely/useOptimizelyExperimentVariation';
import { getBrowserLanguage } from '@/utils/browserLanguage.util';

export interface ExperimentLanguageConfig {
  shouldShowEnglish: boolean;
  langKey: 'en' | 'de';
}

/**
 * Hook for A/B test language detection and switching
 * @returns Language configuration object
 */
export const useExperimentLanguage = (): ExperimentLanguageConfig => {
  const experimentEnabled = useOptimizelyExperimentVariation('wohnen_plus_english_upsell', 'variation1');
  const detectedLanguage = getBrowserLanguage();
  const shouldShowEnglish = Boolean(experimentEnabled) && detectedLanguage === 'en';
  const langKey = shouldShowEnglish ? 'en' : 'de';

  return {
    shouldShowEnglish,
    langKey,
  };
};
